/* eslint-disable quotes */
import { h } from 'vue';
import { vimeo } from '../../vimeo';

const body = `<h4>Tangent edge w.r.t. face</h4>

<p>Make an edge tangent with respect to a face. The tangency is fixed.</p>

<div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="${vimeo('703231577')}" loading="lazy"
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
</div>

<ul class='shortcuts'>
    <li class='shortcuts__item'><b>Shortcuts:</b></li>
    <li class='shortcuts__item'>No shortcuts for this operation</li>
</ul>`;

export default function EdgeToFaceTangencyTooltip() {
    return h('div', { innerHTML: body });
}
